import React from 'react';
import { IonToast } from '@ionic/react';

const Notification = ({ message, color, onDidDismiss }) => (
  <IonToast
    isOpen={true}
    message={message}
    color={color}
    duration={2000}
    position="top"
    onDidDismiss={onDidDismiss}
  />
);

export default Notification;
